import { merge, Observable, of } from "rxjs";
import { filter, tap } from "rxjs/operators";
import { ExtendedMediaStream } from "../extended-media-stream";

export function mapStreamToAudio(
  stream: ExtendedMediaStream,
  audio: HTMLAudioElement
) {
  return new Observable<void>((subscriber) => {
    audio.srcObject = stream.stream;

    const sub1 = merge(
      of(void 0),
      stream.addTrack$.pipe(filter((_) => _.kind === "audio")),
      stream.removeTrack$.pipe(filter((_) => _.kind === "audio"))
    )
      .pipe(tap(() => subscriber.next()))
      .subscribe();

    return () => {
      sub1.unsubscribe();
    };
  });
}
